// ============================================================
// metadata.nav.ts — Phase-3 migration descriptor
// ------------------------------------------------------------
// Component-free, data-only navigation descriptor for the organization
// Metadata feature (parent + Schemas / Value sets children). Imports ONLY
// pure types/constants (@twist/ui-navigation types + @twist/core security
// primitives) — no component / feature code.
//
// Security mirrors the STRICTER of the legacy chrome: the legacy sidebar
// "Metadata" group required requireOrganization + (Schemas_Read OR
// ValueSets_Read), and each sub-item carried its own stricter read perm.
// We keep those stricter NAV constraints (the /metadata route guard itself
// carried no permission) so nav-visible ⊆ route-accessible.
// ============================================================
import { OrgPermissions } from '@twist/core';
import type { NavDescriptor } from '@twist/ui-navigation';

export const metadataNav: NavDescriptor = {
  id: 'metadata',
  path: '/metadata',
  label: 'Metadata',
  icon: 'rssi',
  group: 'Organization',
  // Organization section = 20s; Metadata third (after Products, Devices).
  order: 22,
  surfaces: ['sidebar', 'palette'],
  security: {
    requireOrganization: true,
    orgPermissions: [
      OrgPermissions.MyOrganization__Metadata_Schemas_Read,
      OrgPermissions.MyOrganization__Metadata_ValueSets_Read,
    ],
  },
  children: [
    {
      id: 'metadata-schemas',
      path: '/metadata/schemas',
      label: 'Schemas',
      group: 'Organization',
      surfaces: ['sidebar', 'palette'],
      security: {
        requireOrganization: true,
        orgPermissions: [OrgPermissions.MyOrganization__Metadata_Schemas_Read],
      },
    },
    {
      id: 'metadata-value-sets',
      path: '/metadata/value-sets',
      label: 'Value sets',
      group: 'Organization',
      surfaces: ['sidebar', 'palette'],
      security: {
        requireOrganization: true,
        orgPermissions: [OrgPermissions.MyOrganization__Metadata_ValueSets_Read],
      },
    },
  ],
};
